import { Request } from '../../Servidor/Request';

export class PoisonRequest {
    private sgepveneno: number;
    private nome: string;
    private codigo: string

    constructor(sgepveneno: number, nome: string, codigo: string) {
        this.sgepveneno = sgepveneno;
        this.nome = nome;
        this.codigo = codigo
    }


    /**
     * Getter sgepveneno
     * @return {number}
     */
    public getSgepveneno(): number {
        return this.sgepveneno;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
    /**
     * Getter codigo
     * @return {string}
     */
    public getCodigo(): string {
        return this.codigo;
    }
}

export class PoisonStructRequest {
    private sgepveneno: number;

    constructor(sgepveneno: number) {
        this.sgepveneno = sgepveneno;
    }


    /**
     * Getter sgepveneno
     * @return {number}
     */
    public getSgepveneno(): number {
        return this.sgepveneno;
    }


}

export class PoisonStructResponse {
    private sgepveneno: number;
    private nome: string;

    constructor(sgepveneno: number, nome: string) {
        this.sgepveneno = sgepveneno;
        this.nome = nome;
    }


    /**
     * Getter sgepveneno
     * @return {number}
     */
    public getSgepveneno(): number {
        return this.sgepveneno;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
}

export class PoisonInteractor {
    public fetchSave(request: PoisonRequest): PromiseLike<Boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/veneno/salvar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                let response = rs.Status == "Sucesso"
                res(response)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: PoisonStructRequest): PromiseLike<PoisonStructResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/veneno/buscar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}